window.addEventListener('DOMContentLoaded', (event) => {
  const article = document.getElementById("single-article");
  const headings = article.querySelectorAll("h2, h3");
  const toc = document.getElementById("toc");
  const totalHeadings = headings.length;

  let tocOl = document.createElement("ol");
  let tocFragment = new DocumentFragment();
  let mainLi = null;
  let subUl = null;
  let subLi = null;
  let isSibling = false;

  const anchorMap = {}; // 🔹 For scroll spy tracking

  if (totalHeadings > 1) {
    for (let element of headings) {
      let anchor = document.createElement("a");
      let anchorText = element.innerText;
      anchor.innerText = anchorText;

      let elementId = anchorText.replaceAll(" ", "-").toLowerCase().replace(/[^\w-]+/g, '');
      anchor.href = "#" + elementId;
      element.id = elementId;

      // 🔹 Store anchor for highlighting later
      anchorMap[elementId] = anchor;

      // ⬇️ Smooth scroll with offset
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const headerOffset = window.tocHeaderOffset || 0;
        const targetElement = document.getElementById(elementId);
        const elementPosition = targetElement.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      });

      let level = element.nodeName;

      if ("H3" === level) {
        if (mainLi) {
          subLi = document.createElement("li");
          subLi.appendChild(anchor);

          if (isSibling === false) {
            subUl = document.createElement("ul");
          }
          subUl.appendChild(subLi);
          mainLi.appendChild(subUl);

          isSibling = true;
        }
      } else {
        mainLi = document.createElement("li");
        mainLi.appendChild(anchor);
        tocFragment.appendChild(mainLi);
        isSibling = false;
        subUl = null;
      }
    }

    tocOl.append(tocFragment);
    toc.append(tocOl);
  } else {
    toc.style.display = "none";
  }

  // 🔥 ADD THIS SECTION FOR ACTIVE LINK HIGHLIGHTING:
  window.addEventListener('scroll', () => {
    let scrollPos = window.scrollY + 210; // Adjust offset for accuracy

    let currentId = '';
    for (let heading of headings) {
      if (heading.offsetTop <= scrollPos) {
        currentId = heading.id;
      }
    }

    // Remove existing "active" classes
    for (let key in anchorMap) {
      anchorMap[key].classList.remove('active');
    }

    if (currentId && anchorMap[currentId]) {
      anchorMap[currentId].classList.add('active');
    }
  });
});
